import _createForOfIteratorHelper from "/home/circleci/project/workspaces/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import _regeneratorRuntime from "/home/circleci/project/workspaces/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/home/circleci/project/workspaces/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _toConsumableArray from "/home/circleci/project/workspaces/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import { CodedError, Platform } from 'expo-modules-core';
import FontObserver from 'fontfaceobserver';
import { FontDisplay } from './Font.types';

function getFontFaceStyleSheet() {
  if (!Platform.isDOMAvailable) {
    return null;
  }

  var styleSheet = getStyleElement();
  return styleSheet.sheet ? styleSheet.sheet : null;
}

function getFontFaceRules() {
  var sheet = getFontFaceStyleSheet();

  if (sheet) {
    // @ts-ignore: rule iterator
    var rules = _toConsumableArray(sheet.cssRules);

    var items = [];

    for (var i = 0; i < rules.length; i++) {
      var rule = rules[i];

      if (rule instanceof CSSFontFaceRule) {
        items.push({
          rule: rule,
          index: i
        });
      }
    }

    return items;
  }

  return [];
}

function getFontFaceRulesMatchingResource(fontFamilyName, options) {
  var rules = getFontFaceRules();
  return rules.filter(function (_ref) {
    var rule = _ref.rule;
    return rule.style.fontFamily === fontFamilyName && (options && options.display ? options.display === rule.style.fontDisplay : true);
  });
}

export default {
  get name() {
    return 'ExpoFontLoader';
  },

  unloadAllAsync: function unloadAllAsync() {
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var element;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (Platform.isDOMAvailable) {
                _context.next = 2;
                break;
              }

              return _context.abrupt("return");

            case 2:
              element = document.getElementById(ID);

              if (element && element instanceof HTMLStyleElement) {
                document.removeChild(element);
              }

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  unloadAsync: function unloadAsync(fontFamilyName, options) {
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var sheet, items, _iterator, _step, item;

      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              sheet = getFontFaceStyleSheet();

              if (sheet) {
                _context2.next = 3;
                break;
              }

              return _context2.abrupt("return");

            case 3:
              items = getFontFaceRulesMatchingResource(fontFamilyName, options);
              _iterator = _createForOfIteratorHelper(items);

              try {
                for (_iterator.s(); !(_step = _iterator.n()).done;) {
                  item = _step.value;
                  sheet.deleteRule(item.index);
                }
              } catch (err) {
                _iterator.e(err);
              } finally {
                _iterator.f();
              }

            case 6:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }))();
  },
  loadAsync: function loadAsync(fontFamilyName, resource) {
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
      var canInjectStyle, style;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              if (Platform.isDOMAvailable) {
                _context3.next = 2;
                break;
              }

              return _context3.abrupt("return");

            case 2:
              canInjectStyle = document.head && typeof document.head.appendChild === 'function';

              if (canInjectStyle) {
                _context3.next = 5;
                break;
              }

              throw new CodedError('ERR_WEB_ENVIRONMENT', "The browser's `document.head` element doesn't support injecting fonts.");

            case 5:
              style = _createWebStyle(fontFamilyName, resource);
              document.head.appendChild(style);

              if (isFontLoadingListenerSupported()) {
                _context3.next = 9;
                break;
              }

              return _context3.abrupt("return");

            case 9:
              return _context3.abrupt("return", new FontObserver(fontFamilyName, {
                display: resource.display
              }).load());

            case 10:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }))();
  }
};
var ID = 'expo-generated-fonts';

function getStyleElement() {
  var element = document.getElementById(ID);

  if (element && element instanceof HTMLStyleElement) {
    return element;
  }

  var styleElement = document.createElement('style');
  styleElement.id = ID;
  styleElement.type = 'text/css';
  return styleElement;
}

function _createWebStyle(fontFamily, resource) {
  var fontStyle = "@font-face {\n    font-family: ".concat(fontFamily, ";\n    src: url(").concat(resource.uri, ");\n    font-display: ").concat(resource.display || FontDisplay.AUTO, ";\n  }");
  var styleElement = getStyleElement(); // @ts-ignore: TypeScript does not define HTMLStyleElement::styleSheet. This is just for IE and
  // possibly can be removed if it's unnecessary on IE 11.

  if (styleElement.styleSheet) {
    var styleElementIE = styleElement;
    styleElementIE.styleSheet.cssText = styleElementIE.styleSheet.cssText ? styleElementIE.styleSheet.cssText + fontStyle : fontStyle;
  } else {
    var textNode = document.createTextNode(fontStyle);
    styleElement.appendChild(textNode);
  }

  return styleElement;
}

function isFontLoadingListenerSupported() {
  var userAgent = window.navigator.userAgent; // WebKit is broken https://github.com/bramstein/fontfaceobserver/issues/95

  var isIOS = !!userAgent.match(/iPad|iPhone/i);
  var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent); // Edge is broken https://github.com/bramstein/fontfaceobserver/issues/109#issuecomment-333356795

  var isEdge = userAgent.includes('Edge'); // Internet Explorer

  var isIE = userAgent.includes('Trident'); // Firefox

  var isFirefox = userAgent.includes('Firefox');
  return !isSafari && !isIOS && !isEdge && !isIE && !isFirefox;
}